import React, { useEffect, useRef, useState } from 'react'
import './image.scss'
import { images } from 'theme'
import styles from '../../pages/auth/auth.module.scss'
import {  uploadBytesResumable, getDownloadURL } from 'firebase/storage'
import Spinner from '../Spinner'
import { storage, storageRef } from "utils/firebase"
const Image = (props) => {
    const inputRef = useRef(null)
    const [imageLocalURL, setImageLocalURL] = useState('')
    const [loading, setLoading] = useState(false)
    const [imageURL, setImageURL] = useState('')

    useEffect(() => {
        console.log('props.value', props.value)
        setImageURL(props.value?.url || null)
        if (props.value?.data) setImageLocalURL(URL.createObjectURL(props.value.data))
    }, [props.value])

    const onRemoveImage = () => {
        console.log('onRemoveImage ', props.slug)
        props.formikProps.setFieldValue(props.slug, null )
    }
    const saveImage = (image, callback) => {
        console.log('saveImage image', image)
        if (image == null) {
            callback(null)
            return
        }
        setLoading(true)
        
        const imageRef = storageRef(storage, props.path);
        let uploadTask = uploadBytesResumable(imageRef, image);
        
        uploadTask.on('state_changed', 
            (snapshot) => {
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                console.log(`firebasestorage Upload is ${progress}% done`)
                switch (snapshot.state) {
                    case 'paused':
                        console.log('firebasestorage Upload is paused')
                        break
                    case 'running':
                        console.log('firebasestorage Upload is running')
                        break
                    default:
                        break
                }
            },
            (error) => {
                console.log('firebasestorage error ', error)
                setLoading(false)
                callback(null)
                // Handle unsuccessful uploads
            },
            () => {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('firebasestorage File available at', downloadURL)
                    setLoading(false)
                    callback(downloadURL)
                }).catch((error) => {
                    console.log('firebasestorage getDownloadURL error ', error)
                    setLoading(false)
                    callback(null)
                })
            }
        );
    }

    const handleFileChange = (e) => {
        console.log('handleFileChange e', e)
        console.log('handleFileChange e?.target', e?.target)
        console.log('handleFileChange e?.target.value', e?.target.files)
        const image = e?.target.files[0]
        console.log('handleFileChange props.formikProps ', props.formikProps)
        if(props.path){
            saveImage(image, (url)=>{
                props.formikProps.setFieldValue(props.slug, { url: url })
            })
        }else{
            props.formikProps.setFieldValue(props.slug, { data: image })
        }
        //setImageLocalURL(localImage)
    }

    return (
        <div
            style={props.styles || {}}
        >
            <span>{props.label}</span>
            {loading? (
                <div className={styles.placeHolderCard}>
                    <Spinner color={"black"}  loading/>
                </div>
            ): imageURL || imageLocalURL ? (
                <div className={styles.placeHolderCard}>
                    <img
                        src={imageURL || imageLocalURL}
                        className={styles.filledImage}
                        alt={props?.slug === 'healthCardFront' ? 'healthCardFront' : 'healthCardBack'} />

                    <img
                        src={images.removeIcon}
                        className={styles.removeIcon}
                        alt={'x'} onClick={onRemoveImage}/>
                </div>
            ) : (
                <>
                    <input
                        ref={inputRef}
                        id='car'
                        type='file'
                        accept='image/*'
                        capture='camera'
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                    <div className={styles.placeHolderCard}
                         onClick={() => inputRef.current.click()}>
                        <img
                            src={props?.slug === 'healthCardFront' ? images.healthCardFront : images.healthCardBack}
                            className={styles.placeHolderImage}
                            alt={props?.slug === 'healthCardFront' ? 'healthCardFront' : 'healthCardBack'} />
                    </div>
                </>
            )}
        </div>
    )
}

export default Image
